<template>
    <app-layout>
        <template #header>
            <FarmTitle :farm="farm">
                Neuer Kunde
            </FarmTitle>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">

                    <div class="p-8 pb-1">
                        <div v-if="current_step === 1">
                            <div>
                                <h3 class="text-lg leading-6 font-medium text-gray-900">
                                    Persönliche Informationen
                                </h3>
                            </div>
                            <div class="mt-6 md:grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                <div class="col-span-6">
                                    <label for="name" class="block text-sm font-medium text-gray-700" >
                                        Name
                                    </label>
                                    <div class="mt-1">
                                        <input type="text" name="first_name" id="name" v-model="form.name" autocomplete="name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                        <jet-input-error :message="form.errors.name" />
                                    </div>
                                </div>
                                <div class="col-span-6">
                                    <label for="email" class="block text-sm font-medium text-gray-700" >
                                        E-Mail
                                    </label>
                                    <div class="mt-1">
                                        <input type="text" name="first_name" id="email" v-model="form.email" autocomplete="email" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                        <jet-input-error :message="form.errors.email" />
                                    </div>
                                </div>
                                <div class="col-span-6">
                                    <label for="kdnr" class="block text-sm font-medium text-gray-700" >
                                        Kdnr überschreiben? (leer lassen, wenn nicht)
                                    </label>
                                    <div class="mt-1">
                                        <input type="text" name="kdnr" id="kdnr" v-model="form.kdnr" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                        <jet-input-error :message="form.errors.kdnr" />
                                    </div>
                                </div>
                            </div>
                            <div class="pt-5 pb-8">
                                <div class="flex justify-end">
                                    <inertia-link :href="route('farm.customers', {farm: farm})" type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        Abbrechen
                                    </inertia-link>
                                    <button @click="form.post(route('farm.customers.store', {farm: farm}), { onSuccess: () => { current_step = 2 }})" class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        Kunde erstellen
                                    </button>
                                </div>
                            </div>
                        </div>
                        <GenerateSepaPDF v-if="current_step === 2" :sepa="sepa" :customer="customer"></GenerateSepaPDF>
                    </div>

                    <nav aria-label="Progress">
                        <ol class="border border-gray-300 rounded-md divide-y divide-gray-300 md:flex md:divide-y-0">
                            <li v-for="(step, stepIdx) in steps" :key="step.name" class="relative md:flex-1 md:flex">
                                <span v-if="step.id < current_step" :href="step.href" class="group flex items-center w-full">
                                  <span class="px-6 py-4 flex items-center text-sm font-medium">
                                    <span class="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-indigo-600 rounded-full group-hover:bg-indigo-800">
                                      <CheckIcon class="w-6 h-6 text-white" aria-hidden="true" />
                                    </span>
                                    <span class="ml-4 text-sm font-medium text-gray-900">{{ step.name }}</span>
                                  </span>
                                </span>
                                <span v-else-if="step.id == current_step" :href="step.href" class="px-6 py-4 flex items-center text-sm font-medium" aria-current="step">
                                  <span class="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-indigo-600 rounded-full">
                                    <span class="text-indigo-600">{{ step.id }}</span>
                                  </span>
                                    <span class="ml-4 text-sm font-medium text-indigo-600">{{ step.name }}</span>
                                </span>
                                <span v-else class="group flex items-center">
                                  <span class="px-6 py-4 flex items-center text-sm font-medium">
                                    <span class="flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full group-hover:border-gray-400">
                                      <span class="text-gray-500 group-hover:text-gray-900">{{ step.id }}</span>
                                    </span>
                                    <span class="ml-4 text-sm font-medium text-gray-500 group-hover:text-gray-900">{{ step.name }}</span>
                                  </span>
                                </span>
                                <template v-if="(stepIdx !== steps.length - 1)">
                                    <!-- Arrow separator for lg screens and up -->
                                    <div class="hidden md:block absolute top-0 right-0 h-full w-5" aria-hidden="true">
                                        <svg class="h-full w-full text-gray-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
                                            <path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </template>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import FarmTitle from "@/Layouts/FarmTitle";
import { CheckIcon, ChevronLeftIcon } from '@heroicons/vue/solid';
import GenerateSepaPDF from "@/Modules/GenerateSepaPDF";
import JetInputError from "@/Jetstream/InputError";

export default {
    name: "Index",
    components: {FarmTitle, AppLayout, CheckIcon, GenerateSepaPDF, ChevronLeftIcon, JetInputError},
    props: ['farm', 'sepa', 'customer'],
    data() {
        return {
            steps: [
                { id: '1', name: 'Stammdaten' },
                { id: '2', name: 'SEPA-Mandat' },
            ],
            current_step: 1,
            form: this.$inertia.form({
                name: '',
                email: '',
                kdnr: null,
            })
        }
    },
    mounted() {
        if(this.customer) this.current_step = 2;
    }
}
</script>

<style scoped>

</style>
